<h1 class="text-[24px] text-primary m-[2%]">{{ title }}</h1>
<div class="mx-[2%]">
  <dal-pagination-bar
    (PageChangeEvent)="pageChanged($event)"
    [searchCount]="applyFilters(jobList).length"
    [itemsPerPage]="itemsPerPage"
    [item]="'Job'"
  >
    <div class="flex flex-row flex-wrap form-fields">
      <mat-form-field appearance="fill" class="custom-mat-form-field">
        <mat-icon matPrefix class="text-black">search</mat-icon>
        <mat-label>User</mat-label>
        <input
          matInput
          [(ngModel)]="searchkey"
          (keydown.enter)="search($event)"
        />
      </mat-form-field>
      <mat-form-field appearance="fill" class="custom-mat-form-field">
        <mat-label>Status</mat-label>
        <mat-select
          (selectionChange)="statusChanged($event)"
          [(ngModel)]="status"
        >
          @for (status of statusList ;track status.id) {
          <mat-option [value]="status">{{ status.value }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill" class="custom-mat-form-field">
        <mat-label>Type</mat-label>
        <mat-select (selectionChange)="typeChanged($event)" [(ngModel)]="type">
          @for (type of typeList ;track type.id) {
          <mat-option [value]="type">{{ type.value }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <div class="item p-2 self-end text-white">
        <button class="underline cursor-pointer" (click)="reset()">
          Clear All
        </button>
      </div>
    </div>
  </dal-pagination-bar>
  <dal-shared-ui-tabular-data
    [title]="title"
    [dataSource]="getData(jobList)"
    [displayedColumns]="displayedColumns"
    [dialogLink]="dialogLink"
    (dialogOpened)="openDialog($event)"
    (downloadReport)="downloadReport($event)"
  ></dal-shared-ui-tabular-data>
</div>
